import React from 'react';

import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DISPLAYED_OVERRIDE_REASONS = new Set(['Customer Requested Override']);

export const MoverCountIcon = ({ movers, overrideReason }: { movers: number; overrideReason?: string }) => (
  <>
    <FontAwesomeIcon icon={faUsers} />
    <span>
      {movers} {DISPLAYED_OVERRIDE_REASONS.has(overrideReason!) && `(${overrideReason})`}
    </span>
  </>
);
